export default "__VITE_ASSET__mv1qLH01__"